import { render } from "./carimage1.vue?vue&type=template&id=774c115b&scoped=true"
import script from "./carimage1.vue?vue&type=script&lang=js"
export * from "./carimage1.vue?vue&type=script&lang=js"

import "./carimage1.vue?vue&type=style&index=0&id=774c115b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774c115b"]])

export default __exports__